import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SlackService {
  private apiUrl = 'api/slack';

  constructor(@Inject(HttpClient) private http: HttpClient) {}

  send(data: any): Observable<any> {
    return this.http.post(this.apiUrl, data);
  }
}
